<svg
  class="graphContainer associations"
  id="graphContainer"
  width="100%"
  height="100%"
  #graphContainer
></svg>
